import React from 'react'
import styled from 'styled-components'
import { TbFileCertificate } from 'react-icons/tb';

export default function Certification() {
  const certificatesList = [
    {
      name:"Java",
      src: "/Assets/certificates/java.jpg",
      link: "https://certificate.codingninjas.com/view/bf689b6f1744fee9"
    },
    {
      name:"Java",
      src: "/Assets/certificates/javahackerrank.jpg",
      link: "https://www.hackerrank.com/certificates/bdf3f4f76cb8"
    },
    {
      name:"Data Structure",
      src: "/Assets/certificates/dsa.jpg",
      link: "https://certificate.codingninjas.com/view/854704c74c2808c5"
    },
    {
      name:"React JS",
      src: "/Assets/certificates/reacthackerrank.jpg",
      link: "https://www.hackerrank.com/certificates/b1c6efe5fa6e"
    },
    {
      name:"Frontend",
      src: "/Assets/certificates/html.jpg",
      link: "https://certificate.codingninjas.com/view/f0663692b30c3d29"
    },
    {
      name:"Backend",
      src:"/Assets/certificates/nodejs.jpg",
      link:"https://certificate.codingninjas.com/view/a35e51c1ca9fa742"
    }
  ]
  return (
    <Wrapper id="Certification">
      <h3 className="section-heading">
        <span><TbFileCertificate /></span>
        <span>Certificates</span>
      </h3>
      <div className="certification-display">
        {
          certificatesList.map((element, index) => {
            return <div title={element.name} className='certificate-container' key={index}> <img alt={index} src={element.src} height="200" width="300" />
              <a rel="noreferrer" target='_blank' href={element.link} className='certificate-details'><button >DETAILS</button></a>
            </div>
          })
        }
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
width: 100%;
display: flex;
flex-direction: column;
align-items: center;
margin: 40px auto;
background-color:rgb(29, 28, 33);


.section-heading {
    width: auto;
    padding: 20px 10px 10px;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
}

.section-heading span {
    font-size: 40px;
    color: var(--section-color);
    padding-top: 10px;
    margin-right: .5rem;
    display: flex;
    align-items: center;
}

.certification-display {
  width:80%;
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  justify-content: space-around;
  

  .certificate-container{
    position: relative;
    &:hover{
      img{
        box-shadow: 0px 0px 5px 2px var(--section-color);
        filter: blur(2px);
      }
      .certificate-details{
        display:flex;
        justify-content: center;
        align-items: center;
      }
    }

    .certificate-details{
      position: absolute;
      top:0;
      left:0;
      right:0;
      bottom:0;
      z-index:1;
      display: none;
      text-decoration: none;
      button{
        cursor: pointer;
        height: 3rem;
        width: 8rem;
        box-shadow: 0px 0px 3px 2px var(--section-color);
        background-color: #1d1c21;
        border-radius: 15px;
        color: white;
        
      }
    } 
    img {
      width: 20rem;
      padding: 1rem;
      border-radius: 1rem;
      transition: all .3s ease-in-out;
    }
  }
}
`